import { message } from 'antd';
import { api } from '$app/api';

const sendConfirmRescheduleRequest = async (bookingId, confirmedDate, invitationId) => {
  try {
    const res = await api.post(`/bookings/${bookingId}/confirmreschedule`, {
      caseManagerConfirmedDate: confirmedDate,
      chosenInvitationId: invitationId,
    });
    return res;
  } catch (err) {
    message.error(err);
  }
};

export default sendConfirmRescheduleRequest;
